import * as yup from 'yup';

export const acceptInviteSchema = yup.object().shape({
  organization_name: yup.string().required('Organization Name is required'),
  first_name: yup.string().required('First Name is required'),
  last_name: yup.string().required('Last Name is required'),
  email: yup.string().email('Email address is invalid').required('Email address is required').nullable(),
  accepted_terms: yup.boolean().isTrue('In order to use the tvScientific Platform you must agree to the Terms and Conditions')
});
